const initialDropdown = () => {
  ["turbo:load", "turbo:render"].forEach((event) => {
    document.addEventListener(event, () => {
      const iconMenu = document.getElementById("my-menu-icon");
      const iconHelp = document.getElementById("my-help-icon");
      const iconAnnounce = document.getElementById("my-announcement-icon");
      const menu = document.getElementById("my-menu");
      const help = document.getElementById("my-help");
      const announce = document.getElementById("my-announcement");
      const overlay = document.getElementById("overlay");

      if (!iconHelp || !iconMenu || !iconAnnounce || !menu || !help || !announce || !overlay) return;

      const closeAll = () => {
        menu.classList.remove("d-block");
        announce?.classList.remove("d-block");
        help?.classList.remove("d-block");
        overlay.style.zIndex = "0";
      };

      const open = (target: HTMLElement) => {
        closeAll();
        target.classList.add("d-block");
        overlay.style.zIndex = "1000";
      };

      overlay.addEventListener("click", closeAll);

      iconMenu.addEventListener("click", () => open(menu));
      iconHelp.addEventListener("click", () => open(help));
      iconAnnounce?.addEventListener("click", () => {
        open(announce);
      });
    });
  });
};

export default initialDropdown;
